import { sendValidated } from '@shared/api';
import { ClassifyExpenseResponseSchema } from './schemas';
import { toClassifiedExpenseType } from './mappers';
import type { ClassifiedExpenseType } from '../model/types';

/**
 * Classify a free-text description into an expense category (`POST
 * /api/v1/expense-type/classify-expense`, body `{ description }`). Returns the suggested
 * `{ id, name }` or null (nothing classified, or a superseded "Cancelled" response). The caller
 * debounces this on description change and matches the returned id against the loaded list before
 * applying it — mirroring the mobile auto-classify.
 */
export async function classifyExpense(description: string): Promise<ClassifiedExpenseType | null> {
  const res = await sendValidated(
    'post',
    'api/v1/expense-type/classify-expense',
    { description },
    ClassifyExpenseResponseSchema,
  );
  // Mobile ignores a classify whose `message` is "Cancelled" (a request that was superseded).
  if (res.message === 'Cancelled') return null;
  return toClassifiedExpenseType(res);
}
